import React from 'react';

import { getUserData, twoFactorAuthentication } from '../../services/api/auth';
import TwoFaForm from '../forms/TwoFaForm';
import LoginLayout from './LoginLayout';

interface FormData {
  use_recovery_code: boolean;
  code: string;
}

const TwoFa: React.FC = () => {
  const [loginError, setLoginError] = React.useState<string | null>(null);

  const handle2FaSubmitted = (form: FormData): Promise<void> => {
    setLoginError(null);

    return new Promise((resolve, reject) => {
      const data = form.use_recovery_code ? { recovery_code: form.code } : { code: form.code };

      twoFactorAuthentication(data)
        .then(() => {
          getUserData().then(() => {
            resolve();
            window.location.href = '/';
          });
        })
        .catch((error) => {
          setLoginError(error.response.data.message);
        });
    });
  };

  return (
    <LoginLayout className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin">
      <div className="m-login__wrapper">
        <div className="m-login__logo">
          <a href="/">
            <img src="assets/app/media/img/logos/logo.svg" alt="We Are One World - Crew System" />
          </a>
        </div>

        {loginError && <div className="alert alert-danger">{loginError}</div>}

        <div className="m-login__signin">
          {/*@ts-ignore*/}
          <TwoFaForm handleSubmit={handle2FaSubmitted} />
        </div>
      </div>
    </LoginLayout>
  );
};

export default TwoFa;
